<template>
    <div v-cloak>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>合同下单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="block-container">
            <div class="content-caption dashed">
                <span>选择合同</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">选择合同</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-1-5x bottom-line" :disabled="true" v-model="goodsOrder.title"></el-input>
                    </div>
                </div>
                <div v-if="contractId != null && trackPhaseList != null && trackPhaseList.length > 0" class="form-group center">
                    <div class="form-label ">
                        <label class="required">选择合同阶段</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-select placeholder="请选择" v-model="trackPhaseId">
                            <el-option v-for="trackPhase in trackPhaseList" :key="trackPhase.id" :label="trackPhase.name" :value="trackPhase.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">配货方式</label>
                    </div>
                    <div class="form-value">
                        <el-radio-group v-model="goodsOrder.manualAllocFlag">
                            <el-radio :label="true">手工配货</el-radio>
                            <el-radio :label="false">自动配货</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">税率(%)</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-input v-model="goodsOrder.taxRate" :disabled="contractId != null" @change="taxRateChange(goodsOrder.taxRate)"></el-input>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>配货机构信息</span>
            </div>
            <div class="simple-row">
                <div class="left">
                    <button class="swb-btn swb-btn-small" @click="showShopDlg()">选择机构</button>
                </div>
            </div>
            <table class="custom-tbl">
                <thead class="head">
                <tr class="row">
                    <th class="align-left">机构名称</th>
                    <th class="align-left">地址</th>
                    <th>邮箱</th>
                    <th class="align-left">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr v-if="retailerCom != null" class="row">
                    <td class="align-left">{{retailerCom.name}}</td>
                    <td class="align-left">{{retailerCom.regionName || ''}}{{retailerCom.street || ''}}</td>
                    <td>{{retailerCom.contactEmail}}</td>
                    <td class="align-left">
                        <span class="swb-btn-link" @click="removeRetailerCom()">移除</span>
                    </td>
                </tr>
                <tr class="row" v-else>
                    <td colspan="4">暂无机构信息</td>
                </tr>
                </tbody>
            </table>
            <div v-if="retailerCom != null && retailerCom.shopAddrRegionId != null">
                <div class="content-caption dashed">
                    <span>收货地址</span>
                </div>
                <table class="custom-tbl">
                    <colgroup>
                        <col>
                        <col>
                        <col width="150px">
                    </colgroup>
                    <thead class="head">
                    <tr class="row">
                        <th class="align-left">地址别名</th>
                        <th class="align-left">详细地址</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-if="retailerCom != null" class="row">
                        <td class="align-left">{{retailerCom.shopAddrAlias}}</td>
                        <td class="align-left">{{retailerCom.shopAddrRegionName || ''}}{{retailerCom.shopAddrStreet || ''}}</td>
                        <td>
                            <a class="font-blue" @click="showShopAddrDlg()">更换</a>
                        </td>
                    </tr>
                    <tr class="row" v-else>
                        <td colspan="3"><a @click="showShopAddrDlg()" class="font-blue">选择地址</a></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="content-caption dashed">
                <span>联系人信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">联系人</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-input type="input" v-model="contactName"></el-input>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">联系电话</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-input type="input" v-model="contactTel"></el-input>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>添加商品</span>
            </div>
            <div class="table-layout"><!--error-prompt-->
                <el-form :model="goodsOrder">
                    <el-table ref="multipleTable" :data="goodsOrder.itemList" border tooltip-effect="dark" style="width: 100%">
                        <el-table-column align="left" width="180px" prop="title" label="商品名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="140px" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="140px" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="140px" prop="model" label="型号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="140px" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" width="140px" prop="asmblAccFlag" label="组装件">
                            <template slot-scope="scope">
                                <span>{{scope.row.asmblAccFlag ? '是' : '否'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="220" label="关联定义">
                            <template slot-scope="rows">
                                <div class="inline-block" v-if="rows.row.assetDefId != null && rows.row.assetDefId != -1">{{rows.row.assetDefNo}}</div>
                                <a class="swb-btn-link fr inline-block" @click="delDevcDef(rows.row)">清除</a>
                                <a class="swb-btn-link fr inline-block" @click="setDevcDef(rows.row)">选择</a>
                                <a class="swb-btn-link fr inline-block" v-if="(rows.row.assetDefId == null || rows.row.assetDefId == -1) && (rows.row.asmblAccFlag || (!needAudit && !rows.row.asmblAccFlag))" @click="saveDevcDef(rows.row)">生成定义</a>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="140px" prop="devcName" label="定义全名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="right" width="140px" label="含税价(元)">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.customizable">
                                        <!-- 可定制的商品允许修改价格（含税价），且下单数量只能是1 -->
                                        <el-form-item :prop="'itemList.' + scope.$index + '.price'"> <!-- :rules="{validator: validatePrice, trigger: 'blur'}" -->
                                            <el-input type="text" @change="priceChange(scope.row);" v-model="scope.row.price"></el-input>
                                        </el-form-item>
                                    </span>
                                    <span v-else>
                                        <span v-if="scope.row.price != null">{{scope.row.price}}</span>
                                        <span v-else>0.00</span>
                                    </span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="140px" label="税率(%)">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.taxRate != null">{{scope.row.taxRate}}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="140px" prop="ntxPrice" label="未税价(元)">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.ntxPrice != null">{{scope.row.ntxPrice}}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="140px" prop="wrntPeriod" label="质保期(月)"></el-table-column>
                        <el-table-column align="center" width="100" label="是否可定制">
                            <template slot-scope="scope">
                                <span>{{scope.row.customized ? '是' : '否'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="goodsQuantity" width="140px" label="合同商品数量" v-if="contractId != null && contract != null && contract.kindId != null && contract.kindId == 0">
                            <template slot-scope="scope">
                                <span>{{scope.row.goodsQuantity}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="surplusQuantity" width="140px" label="商品剩余数量" v-if="contractId != null && contract != null && contract.kindId != null && contract.kindId == 0">
                            <template slot-scope="scope">
                                <span>{{scope.row.goodsQuantity - scope.row.surplusQuantity}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="130px" label="下单数量">
                            <template slot-scope="scope">
                                <span v-if="scope.row.customizable">{{scope.row.quantity}}</span>
                                <el-form-item :prop="'itemList.' + scope.$index + '.quantity'" :rules="{validator: validateBaseQuantity, trigger: 'blur'}" v-else>
                                    <el-input :disabled="((scope.row.goodsQuantity - scope.row.surplusQuantity <= 0) && contractId != null && contract.kindId != null && contract.kindId == 0) || scope.row.customized" type="text"
                                              @change="quantityChange(scope);" v-model="scope.row.quantity"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="unit" width="80px" label="单位"></el-table-column>
                        <el-table-column align="right" width="160px" prop="amount" label="下单小计(元)">
                            <template slot-scope="scope">
                                <div v-if="scope.row.amount !=null"><span>{{scope.row.amount}}</span></div>
                                <div v-else><span>0.00</span></div>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="180px" label="说明" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-input type="text" v-model="scope.row.desc"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120px" label="操作" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <a class="swb-btn-link" @click="removeGoods(scope.$index)">移除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
            <div class="content-caption dashed">
                <span>到货日期</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">要求到货日期</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-date-picker :disabled="goodsOrder.desireArriveDays != null" v-model="goodsOrder.desireArriveDate" type="date" placeholder="选择日期" :picker-options="pickerOptions0"></el-date-picker>
                    </div>
                </div>
                <div class="form-group center" v-if="goodsOrder.desireArriveDays != null">
                    <div class="form-label">
                        <label>要求到货天数</label>
                    </div>
                    <div class="form-value">
                        <span>{{goodsOrder.desireArriveDays}} &nbsp 天 </span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>选择{{contractType == 3 ? '服务商' : '供应商'}}</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">{{contractType == 3 ? '服务商' : '供应商'}}名称</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-1-5x bottom-line" :disabled="true" v-model="goodsOrder.sellerName"></el-input>
                    </div>
                </div>
                <div class="form-group top">
                    <div class="form-label">
                        <label>附言</label>
                    </div>
                    <div class="form-value">
                        <el-input type="textarea" class="width-1-5x bottom-line" :rows="3" placeholder="附言最大长度120个字" :maxlength="120" v-model="goodsOrder.postscript"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary" @click="prevContract">返回</button>
            <button class="swb-btn swb-btn-small" @click="saveGoodsOrder">保存</button>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {checkUserActionPerm} from '../index'
    import {openRetailerComListForSelectDlg} from '../retailer/selectDlg';
    import {showMerchtDevcDefSelectDlg, openDevcDefSaveDlg} from '../devcDef/showDlg'
    import {showAsmblAccDefSelectDlg, openAccDefSaveDlg} from '../asmblAcc/dialog'
    import {getMerchantBizParam} from '../asset/assetMain'

    import contractApi from '../../api/contract'
    import userApi from '../../api/user'
    import goodsOrderApi from '../../api/goodsOrder'
    import merchtFinacApi from '../../api/merchtFinac'
    import retailerApi from '../../api/retailer'
    import devcDefApi from '../../api/devcDef'
    import asmblAccApi from '../../api/asmblAcc'

    import SwbContractGoodsOrderList from './ContractGoodsOrderList';
    Routes.add(SwbContractGoodsOrderList);

    import GoodsPurchContractList from '../contract/GoodsPurchContractList';
    Vue.regist(GoodsPurchContractList);
    import IntegPurchContractList from '../contract/IntegPurchContractList.vue';
    Vue.regist(IntegPurchContractList);

    export default {
        name: 'swb-save-goods-order',
        path: '/goods/order/create',
        pathOld: '/save/goods/order',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '合同下单',
        notAsResc: true,
        authen: false,
        data: function () {
            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },

                contractId: null,
                //
                goodsOrder: {
                    contractId: null,
                    contractNo: null,
                    contractOriginalNo: null,
                    sellerId: null,
                    sellerName: null,
                    title: null,
                    desireArriveDate: null,
                    manualAllocFlag: false,
                    itemList: []
                },
                trackPhaseId: null,
                trackPhaseList: [],
                goodsOrderAndTradeDto: {
                    invoiceClaimed: false,
                    payWay: null,
                    invoiceType: null,
                    invoiceTitle: null,
                    invoiceContentTag: null,
                    taxPayerNo: null,
                    recvFrame: 0,
                    invoiceSubjectType: 1
                },

                payWayList: [],//支付方式
                payTimingList: [],//支付时机
                recvFrameList: [],//收货时段
                invoiceTypeList: [],//发票类型
                invoiceSubjectTypeList: [],//发票主题
                invoiceContentTagList: [],//发票标签
                bizAreaIds: [], // 合同适用区域ids
                bizFormIds: [], // 合同适用的经营业态ids
                //
                path: null,
                // 配货机构
                retailerCom: null,
                retailerComId: null,
                contractType: null,
                contactName: null,
                contactTel: null,
                goodsPurch: {},
                normalFlag: false,
                needAudit: false,
            }
        },
        created: function () {
            let self = this;
            //
            this.contractId = this.$route.query.contractId || null;
            let bizAreaIdStr = this.$route.query.bizAreaIdStr || null;
            if (!Utils.isNoB(bizAreaIdStr)) {
                this.bizAreaIds = bizAreaIdStr.split(",") || [];
            }
            let bizFormIdStr = this.$route.query.bizFormIdStr || null;
            if (!Utils.isNoB(bizFormIdStr)) {
                this.bizFormIds = bizFormIdStr.split(",") || [];
            }
            let contractType = this.$route.query.contractType || null;
            if (contractType == 1) {
                // 商品采购合同
                this.path = GoodsPurchContractList.path;
            } else if (contractType == 3) {
                // 集成采购合同
                this.path = IntegPurchContractList.path;
            }
            this.contractType = contractType;
            this.goodsPurch = getEnumInfoWith("contractType", 'name', 'GoodsPurch');
            getMerchantBizParam("asset.definition.create.alter.need.audit", function (result) {  // 新增/变更资产定义是否需要审核
                self.needAudit = Utils.isTrue(result);
            }, 0);
            //
            if (!Utils.isNoB(this.contractId)) {
                this.getContractById();
                this.getContractTrackPhase(this.contractId);
            }
        },

        methods: {
            // 获取合同阶段
            getContractTrackPhase: function (contractId) {
                let self = this;
                self.trackPhaseId = null;
                let params = {};
                params.contractId = contractId;
                contractApi.getContractTrackPhaseListByContractId(params, function (reault) {
                    if (reault.type == 'info') {
                        self.trackPhaseList = reault.data;
                        let trackPhaseList = self.trackPhaseList;
                        if (!Utils.isNoB(trackPhaseList) && trackPhaseList.length > 0) {
                            for (let i = 0; i < trackPhaseList.length; i++) {
                                let trackPhase = trackPhaseList[i];
                                if (trackPhase.active) {
                                    self.trackPhaseId = trackPhase.id;
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(reault.message);
                    }
                })
            },
            // 获取适用机构ids
            getAppliedShopIds(callback){
                let self = this;
                let contract = self.contract || {};
                let theLoading = MsgBox.loading();
                contractApi.getContractAppliedShopIds({
                    contractId: contract.id
                }, function (result) {
                    theLoading.close();
                    if (result.type === "info") {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择机构(只选择合同适用的机构)
            showShopDlg: function () {
                let self = this;
                //
                let queryFilter = {
                    checkBox: false
                };
                //
                let contract = self.contract;
                if (!Utils.isNoB(contract) && contract.id > 0) {
                    if (Utils.isTrue(contract.bizAreaFlag)) {
                        queryFilter.bizAreaIds = self.bizAreaIds || [];
                    }
                    queryFilter.bizFormIds = self.bizFormIds || [];
                }
                openRetailerComListForSelectDlg(queryFilter, function (resultData, theDlg) {
                    theDlg.close();
                    self.retailerCom = resultData;
                    self.retailerComId = resultData.id;
                    self.getRetailerAddrListByComId(self.retailerComId);
                    self.getbizAreaPrice();
                    getMerchantBizParam("asset.finac.enabled", function (normalFlagResult) {
                        self.normalFlag = Utils.isTrue(normalFlagResult);
                    }, 2, self.retailerComId);
                });
            },
            // 获取合同商品区域价
            getbizAreaPrice: function () {
                if (!Utils.isNoB(this.contractId)) {
                    let retailerCom = this.retailerCom;
                    if (!Utils.isNoB(retailerCom.bizAreaId)) {
                        //
                        let skuPriceMap = {};
                        let contractGoodsList = this.contract.contractGoodsList || [];
                        for (let i = 0; i < contractGoodsList.length; i++) {
                            let contractGoods = contractGoodsList[i];
                            if (contractGoods.bizAreaFlag) {
                                let sku = skuPriceMap[contractGoods.skuId];
                                if (Utils.isNoB(sku)) {
                                    skuPriceMap[contractGoods.skuId] = contractGoods.contractGoodsAreaPrices;
                                }
                            }
                        }
                        //
                        let goodsOrder = this.goodsOrder || {};
                        let itemList = goodsOrder.itemList || [];
                        for (let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            if (item.bizAreaFlag) {
                                let contractGoodsAreaPriceList = skuPriceMap[item.skuId] || [];
                                for (let j = 0; j < contractGoodsAreaPriceList.length; j++) {
                                    let areaPrice = contractGoodsAreaPriceList[j];
                                    if (areaPrice.bizAreaId == retailerCom.bizAreaId) {
                                        item.price = Utils.isNoB(areaPrice.price) ? 0.00 : parseFloat(areaPrice.price).toFixed(2);
                                        item.ntxPrice = Utils.isNoB(areaPrice.ntxPrice) ? 0.00 : parseFloat(areaPrice.ntxPrice).toFixed(2);
                                        item.amount = parseInt(item.quantity) * parseFloat(item.price);
                                        break;
                                    }
                                }
                            }
                        }
                        goodsOrder.itemList = Utils.merge([], itemList);
                        this.goodsOrder = Utils.merge({}, goodsOrder);
                    }
                }
            },
            getRetailerAddrListByComId: function (shopId) {
                let self = this;

                let postData = {};
                postData.comId = shopId;
                postData.recvFlag = true;
                postData.defRevcFlag = true;
                //
                retailerApi.getRetailerAddrList(postData, function (result) {
                    if (result.type === "info") {
                        let addrList = result.data;
                        let retailerCom = self.retailerCom;
                        if (addrList != null && addrList.length > 0) {
                            let addr = addrList[0];
                            retailerCom.shopAddrAlias = addr.alias;
                            retailerCom.shopAddrRegionId = addr.regionId;
                            retailerCom.shopAddrRegionName = addr.regionName;
                            retailerCom.shopAddrStreet = addr.street;
                        } else {
                            retailerCom.shopAddrAlias = "机构地址";
                            retailerCom.shopAddrRegionId = retailerCom.regionId;
                            retailerCom.shopAddrRegionName = retailerCom.regionName;
                            retailerCom.shopAddrStreet = retailerCom.street;
                        }
                        self.contactName = self.retailerCom.contactName || null;
                        self.contactTel = self.retailerCom.contactTel || null;
                        self.retailerCom = Utils.merge({}, retailerCom);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            showShopAddrDlg: function () {
                let self = this;
                let retailerCom = self.retailerCom;
                Vue.$showDialog({
                    title: '选择机构收货地址',
                    width: 800,
                    height: 500,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-retailer-addr-select :comId="shopId" :checkBox = "false" :addrFlag="true"  ref="swb_retailer_addr_list_select"></swb-retailer-addr-select>' +
                    '</div>',
                    data: {
                        shopId: retailerCom.id
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_retailer_addr_list_select.getDlgResult() || {};
                        if (result.type == 'info') {
                            let shopAddr = result.data;
                            retailerCom.shopAddrAlias = shopAddr.alias;
                            retailerCom.shopAddrRegionId = shopAddr.regionId;
                            retailerCom.shopAddrRegionName = shopAddr.regionName;
                            retailerCom.shopAddrStreet = shopAddr.street;
                            self.retailerCom = Utils.merge({}, retailerCom);
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {}
                })
            },
            removeRetailerCom: function () {
                this.retailerCom = null;
                this.retailerComId = null;
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(this.path, action, null);
            },
            validateBaseQuantity: function (rule, value, callback) {
                if (!Utils.isNaturalStr(value, true)) {
                    callback(new Error('请输入大于0的整数！'));
                } else {
                    callback();
                }

            },
            // 税率变化事件
            taxRateChange: function (taxRate) {
                if (!Utils.isNoB(taxRate)) {
                    if (!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if (taxRateF > 100) {
                            taxRate = null;
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                } else {
                    taxRate = null;
                }
                let goodsOrder = this.goodsOrder || {};
                goodsOrder.taxRate = taxRate;
                let itemList = goodsOrder.itemList || [];
                if (itemList.length > 0) {
                    for (let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        //
                        item.taxRate = taxRate;
                        if (Utils.isNoB(taxRate) || Utils.isNoB(item.price)) {
                            item.ntxPrice = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                        } else {
                            item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                        }
                    }
                }
                goodsOrder.itemList = Utils.merge([], itemList);
                this.goodsOrder = Utils.merge({}, goodsOrder);
                //
                if (Utils.isNoB(taxRate)) {
                    MsgBox.warning("请输入税率！");
                    return;
                }
            },

            prevContract: function () {
                this.$router.back(-1);
            },
            getContractById: function () {
                //
                let self = this;
                let postData = {};
                postData.id = this.contractId;
                //
                let msgBoxDlg = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    msgBoxDlg.close();
                    //TODO  判断合同是否 与当前符合（可用）
//                    let curUserInfo = null;
//                    userApi.getUserInfoByContext(null, function (result) {
//                        if(result.type == 'info') {
//                            curUserInfo = result.data;
//                        } else {
//                            self.$message.error(result.message);
//                        }
//                    });
                    //
                    if (result.type == "info") {
                        let contract = result.data;
                        self.goodsOrder.contractId = contract.id;
                        self.goodsOrder.title = contract.title;
                        self.goodsOrder.contractNo = contract.no;
                        self.goodsOrder.contractOriginalNo = contract.originalNo;
                        self.goodsOrder.sellerId = contract.sndPartyId;
                        self.goodsOrder.sellerType = contract.sndPartyType;
                        self.goodsOrder.sellerName = contract.sndPartyName;
                        self.goodsOrder.desireArriveDate = new Date(contract.desireArriveDate);
                        self.goodsOrder.desireArriveDays = contract.desireArriveDays;
                        self.goodsOrder.taxRate = Utils.isNoB(contract.taxRate) ? 0.00 : parseFloat(contract.taxRate).toFixed(2);
                        //
                        self.contract = contract;

                        //获取合同中的发票信息
                        self.goodsOrderAndTradeDto.payWay = contract.payWay;
                        self.goodsOrderAndTradeDto.invoiceTitle = contract.invoiceTitle;
                        self.goodsOrderAndTradeDto.invoiceType = contract.invoiceType;
                        self.goodsOrderAndTradeDto.invoiceContentTag = contract.invoiceContentTag;
                        self.goodsOrderAndTradeDto.taxPayerNo = contract.taxPayerNo;
                        self.goodsOrderAndTradeDto.buyerId = contract.fstPartyId;
                        self.goodsOrderAndTradeDto.buyerType = contract.fstPartyType;

                        let contractGoodsList = contract.contractGoodsList;
                        let itemList = self.goodsOrder.itemList || [];
                        for (let i = 0; i < contractGoodsList.length; i++) {
                            let goodsOrderItem = {};
                            goodsOrderItem.title = contractGoodsList[i].name;
                            goodsOrderItem.contactGoodsId = contractGoodsList[i].id;
                            goodsOrderItem.goodsId = contractGoodsList[i].goodsId;
                            goodsOrderItem.skuId = contractGoodsList[i].skuId;
                            goodsOrderItem.catId = contractGoodsList[i].catId;
                            goodsOrderItem.catName = contractGoodsList[i].catName;
                            goodsOrderItem.brandId = contractGoodsList[i].brandId;
                            goodsOrderItem.brandName = contractGoodsList[i].brandName;
                            goodsOrderItem.model = contractGoodsList[i].model;
                            goodsOrderItem.fixedSpec = contractGoodsList[i].fixedSpec;
                            goodsOrderItem.assetDefId = contractGoodsList[i].assetDefId;
                            goodsOrderItem.assetDefNo = contractGoodsList[i].assetDefNo;
                            goodsOrderItem.asmblAccFlag = contractGoodsList[i].asmblAccFlag;
                            goodsOrderItem.devcName = contractGoodsList[i].title;
                            goodsOrderItem.wrntPeriod = contractGoodsList[i].wrntPeriod;
                            goodsOrderItem.goodsQuantity = contractGoodsList[i].quantity;
                            goodsOrderItem.customized = contractGoodsList[i].customized;
                            goodsOrderItem.customizable = contractGoodsList[i].customized;
                            goodsOrderItem.quantity = Utils.isTrue(goodsOrderItem.customizable) ? 1 : null;
                            goodsOrderItem.price = Utils.isNoB(contractGoodsList[i].price) ? 0.00 : parseFloat(contractGoodsList[i].price).toFixed(2);
                            goodsOrderItem.taxRate = Utils.isNoB(contractGoodsList[i].taxRate) ? 0.00 : parseFloat(contractGoodsList[i].taxRate).toFixed(2);
                            goodsOrderItem.ntxPrice = Utils.isNoB(contractGoodsList[i].ntxPrice) ? goodsOrderItem.price : parseFloat(contractGoodsList[i].ntxPrice).toFixed(2);
                            goodsOrderItem.amount = Utils.isTrue(goodsOrderItem.customized) ? goodsOrderItem.price : 0.00;
                            goodsOrderItem.surplusQuantity = 0;
                            goodsOrderItem.unit = contractGoodsList[i].unit;
                            goodsOrderItem.vendorUknoFlag = false;
                            goodsOrderItem.setupFlag = false;
                            goodsOrderItem.asmblFlag = false;
                            goodsOrderItem.asmblAccFlag = contractGoodsList[i].asmblAccFlag;
                            goodsOrderItem.arriveDays = null;
                            goodsOrderItem.bizAreaFlag = contractGoodsList[i].bizAreaFlag;
                            itemList.push(goodsOrderItem);
                        }
                        self.goodsOrder.itemList = Utils.merge([], itemList);
                        //
                        // self.selectInvoiceType();
                        self.selectPayWay();
                        // self.selectInvoiceCtntTag();
                        self.selectPayTiming();
                        self.recvFrameList = getEnumList('recvFrame');
                        self.invoiceSubjectTypeList = getEnumList('invoiceSubjectType');
                        self.getContractGoodsurplusQuantityS(contract.no, self.goodsOrder.itemList);
                    }
                    else {
                        MsgBox.error("找不到给定的合同");
                    }
                });
            },
            quantityChange: function (scope) {
                if (!Utils.isNaturalStr(scope.row.quantity, true)) {
                    Toast.show("【" + scope.row.title + "】请输入有效的下单数量！");
                    return false;
                }
                let contract = this.contract || {};
                if (!Utils.isNoB(this.contractId) && !Utils.isNoB(contract.kindId) && contract.kindId == 0) {
                    if (scope.row.quantity > (scope.row.goodsQuantity - scope.row.surplusQuantity)) {
                        Toast.show("【" + scope.row.title + "】请输入有效的下单数量！");
                        return;
                    }
                }
                let amount = 0;
                this.goodsOrder.quantity = scope.row.quantity;
                this.goodsOrder.price = scope.row.price;
                if (scope.row.quantity != null && scope.row.price != null) {
                    amount = scope.row.quantity * scope.row.price;
                }
                scope.row.amount = amount.toFixed(2);
                this.goodsOrder.itemList = Utils.merge([], this.goodsOrder.itemList);
            },
            validatePrice: function (rule, value, callback) {
                if (!Utils.isMoneyStr(value)) {
                    callback(new Error('必须是金额'));
                } else {
                    let val = parseFloat(value);
                    if (val <= 0) {
                        callback(new Error('输入的金额必须大于0'));
                    } else {
                        let regex = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
                        if (regex.test(val)) {
                            callback();
                        } else {
                            callback(new Error('输入的金额不能超过两位小数'));
                        }
                    }
                }
            },
            priceChange: function (item) {
                //
                let price = item.price;
                if (!Utils.isNoB(price)) {
                    if (!Utils.isMoneyStr(price)) {
                        MsgBox.warning("必须是金额");
                        item.price = null;
                        return;
                    } else {
                        let val = parseFloat(price);
                        if (val <= 0) {
                            MsgBox.warning("输入的金额必须大于0");
                            item.price = null;
                            return;
                        } else {
                            let regex = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
                            if (regex.test(val)) {
                            } else {
                                MsgBox.warning("输入的金额不能超过两位小数");
                                item.price = null;
                                return;
                            }
                        }
                    }
                } else {
                    price = 0;
                }
                //
                let amount = 0;
                let taxRate = item.taxRate;
                taxRate = Utils.isNoB(taxRate) ? 0 : taxRate;
                // 根据税率计算未税价
                item.ntxPrice = (parseFloat(price || 0) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                if (item.quantity != null && !Utils.isNoB(item.price)) {
                    amount = item.quantity * parseFloat(item.price);
                }
                item.amount = amount.toFixed(2);
                item.price = Utils.isNoB(item.price) ? null : parseFloat(item.price).toFixed(2);
                this.goodsOrder.itemList = Utils.merge([], this.goodsOrder.itemList);
            },
            // 提供商品标识码事件
//            vendorUknoFlagChange(row) {
//                let itemList = this.goodsOrder.itemList || [];
//                for(let i = 0; i < itemList.lenth; i++) {
//                    let item = itemList[i];
//                    if(item.id == row.id) {
//                        item.vendorUknoFlag = row.vendorUknoFlag;
//                    }
//                }
//                this.goodsOrder.itemList = Utils.merge([], itemList);
//            },
            saveGoodsOrder: function () {
                let self = this;
                //
                let trackPhaseList = this.trackPhaseList;
                if (!Utils.isNoB(this.contractId) && trackPhaseList != null && trackPhaseList.length > 0 && Utils.isNoB(this.trackPhaseId)) {
                    Toast.show("请选择合同阶段");
                    return;
                }
                if (!Utils.isNoB(this.contractId) && trackPhaseList != null && trackPhaseList.length > 0) {
                    this.goodsOrder.trackPhaseId = this.trackPhaseId;
                    for (let i = 0; i < trackPhaseList.length; i++) {
                        let trackPhase = trackPhaseList[i];
                        if (this.trackPhaseId == trackPhase.id) {
                            this.goodsOrder.trackPhaseName = trackPhase.name;
                        }
                    }
                }
                if (this.retailerCom != null) {
                    let retailerCom = this.retailerCom;
                    this.goodsOrderAndTradeDto.buyerRecvRegionId = retailerCom.shopAddrRegionId;
                    this.goodsOrderAndTradeDto.buyerRecvStreet = retailerCom.shopAddrStreet;

                }
                // @date 2019-02-19 18:08 @author libin @desc 联系人联系电话修改
                if (Utils.isNoB(self.contactName)) {
                    Toast.show("联系人不可为空");
                    return;
                }

                // @date 2019-02-21 10:43 @author libin @desc 增加联系方式校验
                this.goodsOrderAndTradeDto.buyerRecvContactName = self.contactName;
                //
                if (Utils.isNoB(self.contactTel)) {
                    Toast.show("联系电话不可为空");
                    return;
                } else {
                    if (!Utils.isPhoneNo(self.contactTel)) {
                        Toast.show("请填写正确的联系电话！");
                        return false;
                    }
                    this.goodsOrderAndTradeDto.buyerRecvContactTel = self.contactTel;
                }
                //
                let contract = this.contract || {};
                let goodsOrderItemList = this.goodsOrder.itemList || [];
                for (let i = 0; i < goodsOrderItemList.length; i++) {
                    let goodsOrderItem = goodsOrderItemList[i];
                    // 可定制的时候校验金额
                    if (Utils.isTrue(goodsOrderItem.customizable)) {
                        let price = goodsOrderItem.price;
                        if (!Utils.isMoneyStr(price)) {
                            Toast.show("商品【" + goodsOrderItem.title + "】含税价必须是金额！");
                            return false;
                        } else {
                            let val = parseFloat(price);
                            if (val <= 0) {
                                Toast.show("商品【" + goodsOrderItem.title + "】含税价输入的金额必须大于0！");
                                return false;
                            } else {
                                let regex = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
                                if (regex.test(val)) {
                                } else {
                                    Toast.show("商品【" + goodsOrderItem.title + "】含税价输入的金额不能超过两位小数！");
                                    return false;
                                }
                            }
                        }
                    }
                    //
                    let quantity = goodsOrderItem.quantity;
                    if (!Utils.isNaturalStr(quantity)) {
                        Toast.show("商品【" + goodsOrderItem.title + "】需要输入有效的下单数量！");
                        return false;
                    } else if (Utils.isNoB(quantity) || quantity <= 0) {
                        Toast.show("商品【" + goodsOrderItem.title + "】需要输入下单数量！");
                        return false;
                    }
                    //
                    if (!Utils.isNoB(this.contractId) && !Utils.isNoB(contract.kindId) && contract.kindId == 0) {
                        let leftQuantity = goodsOrderItem.goodsQuantity - goodsOrderItem.surplusQuantity;
                        if (!Utils.isNaturalStr(quantity, true)) {
                            if (leftQuantity > 0) {
                                Toast.show("请输入【" + goodsOrderItem.title + "】下单数量！");
                            } else {
                                Toast.show("请移除【" + goodsOrderItem.title + "】商品(不可下单)！");
                            }
                            return false;
                        } else if (quantity > leftQuantity) {
                            Toast.show("【" + goodsOrderItem.title + "】 下单数量超过了 剩余数量！");
                            return false;
                        }
                    }
                    if (Utils.isNoB(goodsOrderItem.assetDefId) || goodsOrderItem.assetDefId == -1) {
                        Toast.show("【" + goodsOrderItem.title + "】 需选择定义！");
                        return false;
                    }
                    goodsOrderItem.quantity = quantity;
                    //
                    goodsOrderItem.trackPhaseId = this.goodsOrder.trackPhaseId;
                    goodsOrderItem.trackPhaseName = this.goodsOrder.trackPhaseName;
                }
                //
                if (goodsOrderItemList.length < 1) {
                    Toast.show("无有效商品，不可下单！");
                    return false;
                }
                //
                let goodsOrder = Utils.merge(this.goodsOrder);
                if (Utils.isNoB(goodsOrder.taxRate)) {
                    Toast.show("税率不可为空！");
                    return false;
                }
                //商户信息
                goodsOrder.sellerId = this.contract.sndPartyId;
                goodsOrder.desireArriveDate = goodsOrder.desireArriveDate.format("yyyy-MM-dd");

                goodsOrder.itemList = goodsOrderItemList.clone();
                // 选择的配货机构信息
                if (Utils.isNoB(self.retailerComId)) {
                    Toast.show("请选择配货机构！");
                    return false;
                }
                goodsOrder.retailerComId = self.retailerComId;

                let goodsOrderAndTradeDto = this.goodsOrderAndTradeDto;
                goodsOrderAndTradeDto.goodsOrder = goodsOrder;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                goodsOrderApi.saveGoodsOrder(goodsOrderAndTradeDto, function (result) {//
                    //
                    lastMsgBoxDlg.close();
                    if (result.type == "info") {
                        MsgBox.success("下单成功");
                        let postData = {};
                        postData.path = SwbContractGoodsOrderList.path;
                        postData.query = {contractId: self.contractId};
                        self.$router.push(postData);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getContractGoodsurplusQuantityS(contractNo, goodsOrderItemList){
                if (goodsOrderItemList != null) {
                    for (let i = 0; i < goodsOrderItemList.length; i++) {
                        let goodsOrderItem = goodsOrderItemList[i];
                        if (goodsOrderItem.skuId != null) {
                            let postData = {};
                            postData.contractNo = contractNo;
                            postData.skuId = goodsOrderItem.skuId;
                            postData.asmblAccFlag = goodsOrderItem.asmblAccFlag;
                            //
                            goodsOrderApi.getGoodsOrderItemQuantityByContractNoAndSkuId(postData, function (result) {
                                if (result.type == "info") {
                                    goodsOrderItem.surplusQuantity = result.data;
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    }
                }
            },
            selectPayTiming: function () {
                let self = this;
                let postData = {};
                postData.merchantId = self.goodsOrder.sellerId;
                merchtFinacApi.getMerchantPayTimingList(postData, function (result) {
                    if (result.type == "info") {
                        let payTimingList = result.data;
                        let dbPayTiminghList = [];
                        for (let i = 0; i < payTimingList.length; i++) {
                            let dbPayTiming = {};
                            let payTiming = payTimingList[i];
                            if (payTiming.defaulted) {
                                self.goodsOrderAndTradeDto.payTiming = payTiming.value;
                            }
                            dbPayTiming.value = payTiming.value;
                            dbPayTiming.text = payTiming.name;
                            dbPayTiminghList.add(dbPayTiming);
                        }
                        if (dbPayTiminghList.length > 0) {
                            self.payTimingList = Utils.merge([], dbPayTiminghList)
                            self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
                        }
                    }
                })
            },
            selectPayWay: function () {
                let self = this;
                let postData = {};
                postData.merchantId = self.goodsOrder.sellerId;
                merchtFinacApi.getMerchantPayWayList(postData, function (result) {
                    if (result.type == "info") {
                        let payWayList = result.data;
                        let dbPayWayList = [];
                        for (let i = 0; i < payWayList.length; i++) {
                            let dbPayWay = {};
                            let payWay = payWayList[i];
                            if (payWay.defaulted && self.goodsOrderAndTradeDto.payWay == null) {
                                self.goodsOrderAndTradeDto.payWay = payWay.value;
                            }
                            dbPayWay.value = payWay.value;
                            dbPayWay.text = payWay.name;
                            dbPayWayList.add(dbPayWay);
                        }
                        if (dbPayWayList.length > 0) {
                            self.payWayList = Utils.merge([], dbPayWayList);
                            self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
                        }
                    }
                })
            },
            // 此方法无用。发票内容标签来自于合同
            selectInvoiceType: function () {
                let self = this;
                let postData = {};
                postData.merchantId = self.goodsOrder.sellerId;
                merchtFinacApi.getMerchantInvoiceTypeListAvailable(postData, function (result) {
                    if (result.type == "info") {
                        let invoiceTypeList = result.data;

                        let invoiceTypeSearchList = [];
                        for (let i = 0; i < invoiceTypeList.length; i++) {
                            let dbInvoiceType = {};
                            let invoiceType = invoiceTypeList[i];
                            if (self.goodsOrderAndTradeDto.invoiceType == null) {
                                if (invoiceType.defaulted) {
                                    self.goodsOrderAndTradeDto.invoiceType = invoiceType.value;
                                }
                            }
                            dbInvoiceType.value = invoiceType.value;
                            dbInvoiceType.text = invoiceType.name;
                            invoiceTypeSearchList.add(dbInvoiceType);
                        }
                        if (invoiceTypeSearchList.length > 0) {
                            self.invoiceTypeList = Utils.merge([], invoiceTypeSearchList);
                            self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
                        }
                    }
                })
            },
            // 此方法无用。发票内容标签来自于合同
            selectInvoiceCtntTag: function () {
                let self = this;
                let postData = {};
                postData.merchantId = self.goodsOrder.sellerId;
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if (result.type == "info") {
                        let invoiceContentTagList = result.data;
                        for (let i = 0; i < invoiceContentTagList.length; i++) {
                            let invoiceContentTag = invoiceContentTagList[i];
                            if (self.goodsOrderAndTradeDto.invoiceContentTag == null) {
                                if (invoiceContentTag.defaulted) {
                                    self.goodsOrderAndTradeDto.invoiceContentTag = invoiceContentTag.name;
                                }
                            }
                        }
                        self.invoiceContentTagList = Utils.merge([], invoiceContentTagList);
                    }
                    self.goodsOrderAndTradeDto = Utils.merge({}, self.goodsOrderAndTradeDto);
                })
            },

            // 移除商品
            removeGoods: function (index) {
                let self = this;
                let goodsOrderItemList = self.goodsOrder.itemList;
                for (let i = 0; i < goodsOrderItemList.length; i++) {
                    if (i == index) {
                        goodsOrderItemList.remove(goodsOrderItemList[i]);
                    }
                }
                self.goodsOrder.itemList = Utils.merge([], goodsOrderItemList);
            },
            setDevcDef(row) {
                let self = this;
                if (row.asmblAccFlag) {
                    showAsmblAccDefSelectDlg({
                        filter: {},
                        checkBox: false
                    }, function (devcDef, dlg) {
                        dlg.close();
                        row.assetDefId = devcDef.id;
                        row.assetDefNo = devcDef.innerCode;
                        row.devcName = devcDef.title;
                        let contactPostData = {
                            id: row.contactGoodsId,
                            assetDefId: devcDef.id,
                            assetDefNo: devcDef.innerCode,
                            asmblAccFlag: true,
                            title: devcDef.title
                        };
                        contractApi.updateContractGoodsAssetInfoById(contactPostData, function (result) {
                            if (result.type == "info") {
                                self.goodsOrder.itemList = Utils.merge({}, self.goodsOrder.itemList);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                } else {
                    showMerchtDevcDefSelectDlg({
                        catId: row.catId,
                        brandId: row.brandId,
                        modelSpec: row.shortSpec,
                        normalized: Utils.isTrue(self.normalFlag) ? true : null
                    }, function (devcDef, dlg) {
                        dlg.close();
                        row.assetDefId = devcDef.id;
                        row.assetDefNo = devcDef.innerCode;
                        row.devcName = devcDef.title;
                        let contactPostData = {
                            id: row.contactGoodsId,
                            assetDefId: devcDef.id,
                            assetDefNo: devcDef.innerCode,
                            asmblAccFlag: false,
                            title: devcDef.title
                        };
                        contractApi.updateContractGoodsAssetInfoById(contactPostData, function (result) {
                            if (result.type == "info") {
                                self.goodsOrder.itemList = Utils.merge({}, self.goodsOrder.itemList);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });

                    });
                }
            },
            delDevcDef(row) {
                let self = this;
                if (row.assetDefId != null) {
                    row.assetDefId = null;
                    row.devcName = null;
                    self.goodsOrder.itemList = Utils.merge({}, self.goodsOrder.itemList);
                }
            },
            saveDevcDef(row){
                let self = this;
                let brandId = row.brandId == null ? -1 : row.brandId;
                let devcDef = {};
                devcDef.name = row.title;
                devcDef.model = row.model;
                devcDef.fixedSpec = row.fixedSpec;
                devcDef.theUnit = row.unit;
                devcDef.catId = row.catId;
                devcDef.catName = row.catName;
                devcDef.brandId = brandId;
                devcDef.brandName = row.brandName;
                devcDef.createDef = true;

                let goodsOrderItemList = self.goodsOrder.itemList;
                if (row.asmblAccFlag) {
                    devcDef.centBuyMode = false;
                    openAccDefSaveDlg({
                        row: devcDef,
                        buildFlag: true
                    }, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.assetType = 3;
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        asmblAccApi.getAsmblAccDefByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                let accDef = result.data;
                                row.assetDefId = accDef.id;
                                row.assetDefNo = accDef.innerCode;
                                row.devcName = accDef.title;
                                let contactPostData = {
                                    id: row.contactGoodsId,
                                    assetDefId: accDef.id,
                                    assetDefNo: accDef.innerCode,
                                    asmblAccFlag: true,
                                    title: accDef.title
                                };
                                contractApi.updateContractGoodsAssetInfoById(contactPostData, function (result) {
                                    if (result.type == "info") {
                                        self.goodsOrder.itemList = Utils.merge({}, goodsOrderItemList);
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                                self.goodsOrder.itemList = Utils.merge({}, goodsOrderItemList);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                } else {
                    devcDef.centBuyRequired = false;
                    devcDef.vendorUknoFlag = false;
                    devcDef.setupFlag = false;
                    devcDef.asmblFlag = false;
                    devcDef.asmblWhileSetup = false;
                    devcDef.stockFifo = false;
                    devcDef.assetType = 0;
                    devcDef.purchFlag = true;
                    let params = {
                        row: devcDef,
                        normalized: Utils.isTrue(self.normalFlag),
                        assetTypeDisabled: true,
                        purchFlagDisabled: true
                    };
                    openDevcDefSaveDlg(params, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.normalized = Utils.isTrue(self.normalFlag);
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        devcDefApi.getMerchtDevcDefInfoByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                let devcDef = result.data;
                                row.assetDefId = devcDef.id;
                                row.assetDefNo = devcDef.innerCode;
                                row.devcName = devcDef.title;
                                let contactPostData = {
                                    id: row.contactGoodsId,
                                    assetDefId: devcDef.id,
                                    assetDefNo: devcDef.innerCode,
                                    asmblAccFlag: false,
                                    title: devcDef.title
                                };
                                contractApi.updateContractGoodsAssetInfoById(contactPostData, function (result) {
                                    if (result.type == "info") {
                                        self.goodsOrder.itemList = Utils.merge({}, goodsOrderItemList);
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });

                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/SaveGoodsOrder.vue